import { render, staticRenderFns } from "./PointsMall.vue?vue&type=template&id=53ced71f&scoped=true&"
import script from "./PointsMall.vue?vue&type=script&lang=js&"
export * from "./PointsMall.vue?vue&type=script&lang=js&"
import style0 from "./PointsMall.vue?vue&type=style&index=0&id=53ced71f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ced71f",
  null
  
)

export default component.exports